import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearSessionReport } from "../../hooks/report";
import { sessionService } from "redux-react-session";
import { logout } from "../../utils/user-manager";
import { useEffect } from "react";

const Logout = () => {
    const authenticated = useSelector((state) => state.session.authenticated);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = async () => {
            dispatch(clearSessionReport());
            await sessionService.deleteSession();
            await sessionService.deleteUser();
            await logout();
            navigate("/login");
        };

        handleLogout();
    }, [authenticated, dispatch, navigate]);

    return null;
};

export default Logout;
